// import BrandLogo from "../../clients/RACING/assets/lego_f1/Lego F1 Logo.png";
import { ReactComponent as MetaMap } from "../../clients/RACING/assets/lego_f1/Monza_LEGO.svg";

// import { ReactComponent as MetaMap } from "../../clients/RACING/assets/lego_f1/Hungaroring_LEGO.svg";

const render = () => {
  return (
    <>
      Win a LEGO<sup>®</sup> Speed Champions Toy of your choosing
    </>
  );
};

export const LEGO_F1_brandVariables = {
  client: "LEGO-gdjkr", // For picking wich leaderboard to show
  tenantId: "LEGO-gdjkr", // For picking wich leaderboard to show
  layoutKeyValue: "LEGO_F1",
  brand: "legof1", // For scss
  gameStyle: "racing", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  // eventCode: "logitech_gamebox_spring_2024", // Needed for fetching correct challenge
  challengeStatus: "ongoing",
  challengeGameType: "f12025",
  brandLogo: null,
  brandLogoType: "img", // "img" | "element" (svg)
  leaderboardLength: 7,
  qrRedirectURL: "https://lego.iplay.dk",
  prize: {
    content: render(),
    nameOf: "", // will be marked in color
    typeOfItem: "", // will be added after nameOf
  },

  disclaimer:
    "By scanning and playing you participate in a competition where the goal is to set the fastest lap time. The fastest 3 participants will each win a prize at the end of the day and are required to collect their prize in person. Prizes will be handed out at 17:45, should a winner not show up to collect their prize by 17:55 at the latest, they forfeit it. Prize consists of a Lego Speed Champions F1 kit which is valued at 249.95 DKK MSRP. LEGO® and the LEGO logo are trademarks of the LEGO Group. ©2024 The LEGO Group. The F1 logo, FORMULA 1, F1, GRAND PRIX and related marks are trademarks of Formula One Licensing BV, a Formula 1 company. All other trademarks, logos and copyrights, including those of the teams featured, are the property of their respective owners. All rights reserved. OFFICIAL LICENSEE OF FORMULA 1®",

  content: {
    generalHeadline: "Beat the fastest time!",
    generalHeadlineAlt: "Set the fastest time!",
    subHeadline: "Lorem ipsum...",
    overviewHeadline: "Lego X F1 winners",
    endscreenHeadline: "Thank you and congratulations to our",
  },

  // metaInfo: {
  //   trackName: "Hungary - Budapest",
  //   playerTeamOrCarKey: "",
  //   playerTeamOrCarValue: "",
  //   map: MetaMap,
  //   1: {
  //     key: "Turns:",
  //     value: "14",
  //   },
  //   2: {
  //     key: "Circuit length:",
  //     value: "4.381 km",
  //   },
  //   3: {
  //     key: "Track difficulty:",
  //     value: "medium",
  //   },
  //   4: {
  //     key: "Lap record:",
  //     value: "1:17.103",
  //   },
  // },

  metaInfo: {
    trackName: "Monza Grand Prix - Italy",
    playerTeamOrCarKey: "",
    playerTeamOrCarValue: "",
    map: MetaMap,
    1: {
      key: "Turns:",
      value: "11",
    },
    2: {
      key: "Length:",
      value: "5.793 km",
    },
    3: {
      key: "Difficulty:",
      value: "very easy",
    },
    4: {
      key: "Record:",
      value: "1:21.046",
    },
  },
};
